import { render, staticRenderFns } from "./UsabilidadeDoSistemaCoordenadorPage.vue?vue&type=template&id=2557109c&scoped=true"
import script from "./UsabilidadeDoSistemaCoordenadorPage.vue?vue&type=script&lang=js"
export * from "./UsabilidadeDoSistemaCoordenadorPage.vue?vue&type=script&lang=js"
import style0 from "./UsabilidadeDoSistemaCoordenadorPage.vue?vue&type=style&index=0&id=2557109c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2557109c",
  null
  
)

export default component.exports